// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yc_q4","icon":"styles_icon__ghri_","title":"styles_title__Lt8OI","description":"styles_description__6yjgl","useDifferentAccountButton":"styles_useDifferentAccountButton__KItAY"};
module.exports.__checksum = "153ace4c5215"